module.exports = __webpack_public_path__ + "img/delay-button.19a57e35.png";